module.exports = __webpack_public_path__ + "img/logo.d64f2b6b.png";